import { render, staticRenderFns } from "./MobileAdminLocalTab.vue?vue&type=template&id=3e5ec8ca&scoped=true"
import script from "./MobileAdminLocalTab.vue?vue&type=script&lang=js"
export * from "./MobileAdminLocalTab.vue?vue&type=script&lang=js"
import style0 from "./MobileAdminLocalTab.vue?vue&type=style&index=0&id=3e5ec8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5ec8ca",
  null
  
)

export default component.exports